import { render, staticRenderFns } from "./Skeleton.vue?vue&type=template&id=a3e62ffe&scoped=true&"
var script = {}
import style0 from "./Skeleton.vue?vue&type=style&index=0&id=a3e62ffe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3e62ffe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
